import { connect } from 'react-redux'
import { IStoreState, IMobilityOptionObject, IAssistanceObject } from '../../types/index'
import {
  getMobilityOptions,
  getMobilityOptionCategories,
  updateMobilityOption
} from 'src/state/actions/mobility-options'
import EditAssistanceModal from 'src/components/global-settings/EditAssistanceModal'
import { getAssistances, updateAssistance } from 'src/state/actions/assistance'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    categories: state.assistanceCategories.items,
    assistances: state.assistances.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    update: (assistance: IAssistanceObject) => {
      return dispatch(updateAssistance(assistance))
    },
    getAssistances: () => {
      return dispatch(getAssistances())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAssistanceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/EditAssistanceModal.ts